import { useRoute } from 'vue-router';
import { useStore } from 'vuex';

export const useApiParams = () => {
  /**
   * APIパラメータを保存する
   * @returns {Promise<void>}
   */
  const save = async () => {
    const store = useStore();
    const route = useRoute();
    const token = route.query.bearertoken || '';
    const treatmentConsultationSeq = route.query.treatmentConsultationSeq || ''
    const treatmentSerialNumber = route.query.treatmentSerialNumber || ''

    // querystringを保存する
    await store.dispatch('apiParams/setTreatmentConsultationSeq', treatmentConsultationSeq);
    await store.dispatch('apiParams/setTreatmentSerialNumber', treatmentSerialNumber);
    await store.dispatch('apiParams/setJwtToken', token);
  };

  return {
    save,
  };
};
